import { AppIdentityCompositeEntity, AppRoleDims, WatchlistEntity, WithUuid } from '@nk/data-entities-lib';

export function filterWatchlistOptions(
  identity: AppIdentityCompositeEntity,
  romeDim: AppRoleDims,
  watchlistByCompany: WithUuid<WatchlistEntity>[] = [],
  inputWatchlistOptions: WithUuid<WatchlistEntity>[] = [],
): WithUuid<WatchlistEntity>[] {
  if (!identity) {
    return [];
  }

  const filterAlreadyAdded = (inputWatchlistOptions || []).filter(
    (existing) => !watchlistByCompany.find((w) => w.uuid === existing.uuid),
  );
  const isSuperuserOrAdmin = !!romeDim?.flags?.superuser || !!identity.app_user?.admin_flag;
  if (isSuperuserOrAdmin) {
    return filterAlreadyAdded;
  } else {
    return filterAlreadyAdded.filter((x) => x.app_membership_uuid === identity.app_membership?.uuid);
  }
}
